export enum ProjectsSortMode {
  LAST_OPENED = 'last_open',
  CREATION_DATE = 'creation_date',
  TITLE = 'title'
}
